import React, { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '../services/api';
import toast from 'react-hot-toast';

const ALL_ROLES = ['GERENCIA', 'RECEPCAO_COMPRAS_AGENDA', 'RECEPCAO_PROJETOS', 'PRODUCAO', 'MONTAGEM_CLIENTE'];

const SettingsClientAccess = () => {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ['client-access-roles'],
    queryFn: () => settingsService.getClientCreateAllowedRoles().then(r => r.data)
  });
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (data?.roles) setSelected(data.roles);
  }, [data]);

  const updateMutation = useMutation({
    mutationFn: (roles) => settingsService.updateClientCreateAllowedRoles(roles).then(r => r.data),
    onSuccess: () => {
      toast.success('Configurações atualizadas');
      // invalidar cache global para que outras telas (e outras abas) atualizem
      queryClient.invalidateQueries(['client-access-roles']);
    },
    onError: (e) => {
      const msg = e?.response?.data?.message || 'Erro ao atualizar configurações';
      toast.error(msg);
    }
  });

  const toggle = (role) => {
    setSelected(prev => prev.includes(role) ? prev.filter(r => r !== role) : [...prev, role]);
  };

  const onSave = () => {
    if (selected.length === 0) {
      toast.error('Selecione ao menos um nível de acesso.');
      return;
    }
    updateMutation.mutate(selected);
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-secondary-900">Acesso aos Clientes</h1>
        <p className="text-secondary-600">Defina quais setores podem visualizar, criar, atualizar e gerenciar clientes. Somente Gerência pode alterar.</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-secondary-900">Níveis de Acesso</h2>
          <p className="text-sm text-secondary-600">Selecione os roles permitidos. Estas permissões se aplicam a todas as operações de clientes.</p>
        </div>
        <div className="card-body">
          {isLoading ? (
            <p>Carregando...</p>
          ) : (
            <div className="space-y-3">
              {ALL_ROLES.map(role => (
                <label key={role} className="flex items-center gap-3">
                  <input type="checkbox" className="h-4 w-4" checked={selected.includes(role)} onChange={() => toggle(role)} />
                  <span className="text-sm text-secondary-800">{role}</span>
                </label>
              ))}
            </div>
          )}
        </div>
        <div className="card-footer justify-end">
          <button className="btn-primary" onClick={onSave} disabled={updateMutation.isLoading}>
            {updateMutation.isLoading ? 'Salvando...' : 'Salvar Configurações'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsClientAccess; 